import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const IntegrationServerToMosaicHeaderCell = ({
  _customRowProps: { integration },
}: HeaderCellProps) => {
  return (
    <Tooltip title={'Number of entities that needs to be created/updated on Mosaic'}>
      <div>Integration Server To Mosaic</div>
    </Tooltip>
  );
};

export default IntegrationServerToMosaicHeaderCell;
